import { RouteRecordRaw } from 'vue-router'

const inventoryRoutes: RouteRecordRaw[] = [
  {
    path: '/inventory',
    name: 'inventory.index',
    component: () => import('@/modules/pms/views/InventoryIndex.vue'),
    meta: {
      pageTitle: 'Inventory',
      breadcrumbs: ['Inventory']
    }
  },
  {
    path: '/inventory/items/:id',
    name: 'inventory-items.show',
    component: () => import('@/modules/pms/views/InventoryItemShow.vue'),
    meta: {
      pageTitle: 'Inventory Item',
      breadcrumbs: ['Inventory']
    }
  }
]

export default inventoryRoutes
